import React from "react"
import withUseRouter, {UseRouterParams} from "../../services/router";
import {MatesComponent, MatesComponentState} from "components/mates-component";
import {Loading} from "@sinossi/mates-react-library";
import {PageHeader, PageSectionTitle, RoutesData} from "components/commons";
import {Box} from "@mui/material";
import MicrojobCard from "components/microjob/detail/form/microjob-card";
import {TaskTable} from "../../components/microjob/detail/task-table/task-table";
import {t} from "@lingui/macro";
import {HistoryTable} from "../../components/microjob/history/history-table";


interface MicrojobDetailProps extends UseRouterParams {

}

interface MicrojobDetailState extends MatesComponentState{
    loading: boolean
}

class MicrojobDetails extends React.Component<MicrojobDetailProps, MicrojobDetailState>
{
    private readonly matesComponent: MatesComponent<MicrojobDetailProps, MicrojobDetailState> = new MatesComponent(this)
    private microjobId: string
    private dataMock: any = {
        profilePhoto: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        name: "Maria Rossi",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
        score: 3,
        feedback: 5,
        address: "Via Peretti, 2, 09121. Cagliari, CA",
        phone: "3271111111",
        email: "maria.rossi@microjob.it"
    }

    private tableMock: any = {
        items: [{
            id: 1,
            title: "Scattare foto",
            status: "assegnata",
            cost: 1000,
            paymentStatus: "PAGATA",
            progress: 30,
        }],
        pagination: {
            currentPage: 0
        }
    }

    private historyMock: any = {
        items: [{
            id: 1,
            activity: "Recuperare documenti catastali",
            date: "10/11/2023",
        }],
        pagination: {
            currentPage: 0
        }
    }

    constructor(props: MicrojobDetailProps)
    {
        super(props)
        this.microjobId = this.props.params.id
        this.state = {
            ...this.matesComponent.setupState(),
            loading: false,
        }
    }

    render () {
        return (
            <Box sx={{pt: 2}}>
                <Loading show={this.state.loading} />
                <PageHeader
                    title={RoutesData.MICROJOB_DETAILS.title}
                    paths={[ RoutesData.DASHBOARD, RoutesData.MICROJOB, RoutesData.MICROJOB_DETAILS, ]}
                    params={{ "MICROJOB_DETAILS": { "id": this.microjobId, } }}
                />
                {!this.state.loading &&
                    <Box sx={{mt: 5}}>
                        <MicrojobCard data={this.dataMock}/>
                    </Box>
                }
                {!this.state.loading &&
                    <Box sx={{mt:3}}>
                        <PageSectionTitle title={t({ id: "microjob.microjob-details.task-table-title", message: "Task Microjob" })} />
                        <TaskTable handleCallback={() => console.log("task table")} data={this.tableMock}/>
                    </Box>
                }
                {!this.state.loading &&
                    <Box sx={{mt:3}}>
                        <PageSectionTitle title={t({ id: "microjob.microjob-details.history-table-title", message: "Storico attività" })} />
                        <HistoryTable handleCallback={() => console.log("history table")} data={this.historyMock} />
                    </Box>
                }

            </Box>
        )
    }

}


export default withUseRouter(MicrojobDetails)
